import { Button, Stack, Typography, useMediaQuery } from "@mui/material"
import BaseModal from "../BaseModal/BaseModal"
import questionMark from "../../assets/images/question-mark.png"
import theme from "../../theme/theme"
import * as Styled from "./PWAModal.styles"

interface PWAConfirmationModalProp {
    openModal: boolean
    onDownloaded?: any
    onDelayDownload?: any
}

const PWAConfirmationModal = ({openModal, onDownloaded, onDelayDownload}: PWAConfirmationModalProp) => {
    const isDesktop = useMediaQuery((theme: any) =>
        theme.breakpoints.up("desktop")
      );

   const confirmationModal = () =>{     
    
    return (
            <Stack direction="column" gap={2} sx={{ alignItems: "center", }}>
                <img alt="question mark logo"src={questionMark}></img>
                <Typography sx={{ fontFamily: 'Slalom Sans', textAlign: "center", fontSize: "20px", fontWeight: 700, lineHeight: "32px", display: "flex", }}>Have you added Gather App to your home screen? </Typography>
                <Typography sx={{ fontFamily: 'Slalom Sans', textAlign: "center", fontSize: "16px", fontWeight: 400, lineHeight: "20px", display: "flex" }}>You won't see this reminder again. If you still need help, find the steps in our FAQ.</Typography>
            {isDesktop ? <Stack direction="row" gap={2}>
                 <Styled.BaseSubtitleActionText
                            variant="modalSubtitle"
                            onClick={onDelayDownload}
                            sx={{ fontFamily: 'Slalom Sans', fontSize: "16px", fontWeight: 700, lineHeight: "100%", display: "flex" }}
                        >
                            Not yet, keep showing 
                        </Styled.BaseSubtitleActionText> 
                <Button variant="contained" onClick={onDownloaded} sx={{ fontFamily: 'Slalom Sans', fontSize: "16px", width: "166px", backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, fontWeight: 700, lineHeight: "100%", display: "flex", padding: "12px 20px", radius: "50px" }}>Yes, dismiss</Button>
            </Stack> : <>
            <Button variant="contained" onClick={onDownloaded} sx={{ fontFamily: 'Slalom Sans', fontSize: "16px", backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, fontWeight: 700, lineHeight: "100%", display: "flex", padding: "12px 20px", radius: "50px" }}>Yes, dismiss</Button>
            <Styled.BaseSubtitleActionText
                            variant="modalSubtitle"
                            onClick={onDelayDownload}
                            sx={{ fontFamily: 'Slalom Sans', fontSize: "16px", fontWeight: 700, lineHeight: "100%", display: "flex" }}
                        >
                            Not yet, keep showing 
                        </Styled.BaseSubtitleActionText> 
            </> }
            </Stack>
        )
}


return (
    <><BaseModal padding="36px 40px 24px 40px" desktopWidth="465px" tabletWidth="342px" mobileWidth="342px" open={openModal} onClose={onDelayDownload}>
    
                {confirmationModal()}
    
            </BaseModal></>
)
}

export default PWAConfirmationModal;